import "../scss/team.scss"
